{
  "toasts": {
    "logoUpdated": "Logo atualizada com sucesso!",
    "logoUploadError": "Erro ao enviar logo",
    "logoRemoved": "Logo removida",
    "logoRemoveError": "Erro ao remover logo",
    "bannerCreated": "Banner criado com sucesso!",
    "bannerCreateError": "Erro ao criar banner",
    "bannerUpdated": "Banner atualizado!",
    "bannerUpdateError": "Erro ao atualizar banner",
    "bannerDeleted": "Banner excluído!",
    "bannerDeleteError": "Erro ao excluir banner",
    "menuItemCreated": "Item de menu criado!",
    "menuItemCreateError": "Erro ao criar item de menu",
    "menuItemUpdated": "Item de menu atualizado!",
    "menuItemUpdateError": "Erro ao atualizar item de menu",
    "menuItemDeleted": "Item de menu excluído!",
    "menuItemDeleteError": "Erro ao excluir item de menu",
    "settingsUpdated": "Configurações atualizadas!",
    "settingsUpdateError": "Erro ao atualizar configurações"
  },
  "branding": {
    "toasts": {
      "saveError": "Não foi possível salvar.",
      "saved": "Identidade atualizada. Os alunos já veem a mudança.",
      "reset": "Identidade restaurada ao padrão."
    },
    "loading": "Carregando…",
    "title": "Identidade visual",
    "subtitle": "Como a sua área de membros aparece para os alunos.",
    "logo": {
      "title": "Logo",
      "description": "Aparece no topo do menu e na tela de entrada. JPG, PNG, SVG ou WEBP, até 2MB."
    },
    "banner": {
      "title": "Imagem de entrada",
      "description": "Ocupa o painel ao lado do formulário de login. JPG, PNG ou WEBP, até 5MB. Sem imagem, aparece a marca da Xtreed."
    },
    "favicon": {
      "title": "Favicon",
      "description": "Ícone da aba do navegador. ICO, PNG ou SVG, até 1MB."
    },
    "colors": {
      "title": "Cores",
      "description": "A cor principal pinta botões, links e destaques da área.",
      "primary": "Cor principal",
      "secondary": "Cor secundária",
      "hex": "{{label}} em hexadecimal"
    },
    "texts": {
      "title": "Textos",
      "welcome": "Saudação de boas-vindas",
      "welcomePlaceholder": "Bem-vindo",
      "footer": "Texto do rodapé",
      "footerPlaceholder": "© Sua escola"
    },
    "save": "Salvar",
    "resetConfirm": "Isto apaga logo, imagem de entrada, favicon e cores. Continuar?",
    "reset": "Restaurar padrão",
    "image": {
      "uploaded": "{{name}} atualizado.",
      "uploadError": "Não foi possível enviar {{nameLower}}.",
      "uploading": "Enviando…",
      "choose": "Escolher arquivo",
      "preview": "Prévia: {{name}}",
      "empty": "Nenhum arquivo enviado"
    },
    "theme": {
      "title": "Tema",
      "description": "Defina se a área do aluno fica clara, escura ou se cada aluno escolhe.",
      "modes": {
        "STUDENT_CHOICE": "Aluno escolhe (claro ou escuro)",
        "LIGHT": "Sempre claro",
        "DARK": "Sempre escuro"
      }
    }
  },
  "customizationForm": {
    "validation": {
      "invalidHex": "Cor deve ser um hexadecimal válido",
      "welcomeRequired": "Texto de boas-vindas é obrigatório",
      "footerRequired": "Texto do rodapé é obrigatório"
    },
    "tabs": {
      "branding": "Marca",
      "colors": "Cores",
      "content": "Conteúdo"
    },
    "uploading": "Enviando...",
    "loaded": "Carregado",
    "loadedFeminine": "Carregada",
    "logo": {
      "title": "Logo",
      "description": "Upload do logo da plataforma (JPG, PNG, SVG - máx. 2MB)",
      "url": "URL do Logo",
      "upload": "Upload Logo",
      "preview": "Logo preview"
    },
    "banner": {
      "title": "Imagem de entrada",
      "description": "Ocupa o painel ao lado do formulário de login (JPG, PNG ou WEBP — máx. 5MB). Sem imagem, aparece a marca da Xtreed.",
      "url": "URL da imagem",
      "upload": "Enviar imagem",
      "preview": "Prévia da imagem de entrada"
    },
    "favicon": {
      "title": "Favicon",
      "description": "Ícone que aparece na aba do navegador (ICO, PNG - máx. 1MB)",
      "url": "URL do Favicon",
      "upload": "Upload Favicon",
      "preview": "Favicon preview"
    },
    "colors": {
      "title": "Esquema de Cores",
      "description": "Defina as cores principais da plataforma",
      "primary": "Cor Primária",
      "primaryHint": "Cor principal dos botões e elementos ativos",
      "secondary": "Cor Secundária",
      "secondaryHint": "Cor para acentos e elementos secundários",
      "preview": "Preview das Cores",
      "primaryShort": "Primária",
      "secondaryShort": "Secundária"
    },
    "texts": {
      "title": "Textos Personalizados",
      "description": "Customize textos que aparecem na plataforma",
      "welcome": "Texto de Boas-vindas",
      "welcomePlaceholder": "Bem-vindo ao Xtreed",
      "welcomeHint": "Texto exibido na página inicial",
      "footer": "Texto do Rodapé",
      "footerPlaceholder": "© 2024 Xtreed. Todos os direitos reservados.",
      "footerHint": "Texto exibido no rodapé de todas as páginas"
    },
    "actions": {
      "reset": "Restaurar Padrões",
      "saving": "Salvando...",
      "save": "Salvar Alterações"
    },
    "preview": {
      "title": "Preview em Tempo Real",
      "description": "Veja como ficará a aparência da plataforma",
      "nav": {
        "courses": "Cursos",
        "tracks": "Trilhas",
        "profile": "Perfil"
      },
      "heroSubtitle": "Aprenda as tecnologias mais modernas do mercado",
      "start": "Começar Agora",
      "learnMore": "Saiba Mais",
      "featuredCourse": "Curso em Destaque",
      "sampleCourse": "React do Zero ao Profissional",
      "popularTrack": "Trilha Popular",
      "platformStudent": "Aluno da plataforma"
    },
    "palette": {
      "title": "Paleta de Cores"
    }
  },
  "cms": {
    "positions": {
      "home": "Home",
      "sidebar": "Sidebar",
      "header": "Header"
    },
    "title": "Personalização",
    "subtitle": "Gerencie banners, menus e seções da plataforma",
    "tabs": {
      "banners": "Banners",
      "menu": "Menu",
      "sections": "Seções da Home",
      "support": "Suporte"
    },
    "actions": {
      "delete": "Excluir",
      "activate": "Ativar",
      "deactivate": "Desativar"
    },
    "status": {
      "inactive": "Inativo"
    },
    "banners": {
      "title": "Banners",
      "description": "Banners são exibidos no dashboard do aluno. Múltiplos banners criam um carrossel automático.",
      "new": "Novo Banner",
      "create": "Criar Banner",
      "fallbackTitle": "Banner",
      "untitled": "Banner sem título",
      "noLink": "Sem link de destino",
      "emptyTitle": "Nenhum banner",
      "emptyDescription": "Adicione banners para exibir no dashboard dos alunos",
      "deleteTitle": "Excluir banner",
      "deleteDescription": "Tem certeza que deseja excluir este banner?"
    },
    "menu": {
      "title": "Menu Personalizado",
      "description": "Adicione links customizados ao menu lateral do aluno",
      "new": "Novo Item",
      "create": "Criar Item",
      "external": "Externo",
      "noUrl": "Sem URL",
      "emptyTitle": "Nenhum item de menu",
      "emptyDescription": "Adicione links ao menu lateral dos alunos",
      "preview": "Preview do Menu",
      "previewLinks": "Links",
      "deleteTitle": "Excluir item de menu",
      "deleteDescription": "Tem certeza que deseja excluir este item de menu?"
    },
    "sections": {
      "description": "Organize os cursos em seções na página inicial dos alunos"
    },
    "support": {
      "title": "Suporte via WhatsApp",
      "description": "Configure o botão de suporte exibido para os alunos",
      "cardTitle": "WhatsApp de Suporte",
      "active": "Suporte ativo",
      "inactive": "Suporte desativado",
      "number": "Número do WhatsApp",
      "numberPlaceholder": "5511999999999",
      "numberHint": "Formato: código do país + DDD + número (ex: 5511999999999)",
      "message": "Mensagem automática",
      "messagePlaceholder": "Olá! Preciso de ajuda com...",
      "messageHint": "Mensagem pré-preenchida ao abrir o WhatsApp",
      "saving": "Salvando...",
      "save": "Salvar Configurações",
      "activeDescription": "O botão do WhatsApp aparecerá no canto inferior direito para os alunos.",
      "inactiveDescription": "Ative o suporte para exibir o botão do WhatsApp para os alunos."
    }
  }
}
